'use es6';

import styled from 'styled-components';
const FilterTag = styled.span.withConfig({
  displayName: "FilterTag",
  componentId: "sc-1x1ji19-0"
})(["span:hover{text-decoration:underline;}"]);
export default FilterTag;